import { HttpClient } from '@angular/common/http';
import { ApplicationInitStatus, Injectable, isDevMode } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
	providedIn: 'root',
})
export class ConfigService {
	public get apiBaseUrl() {
		return this.config.ALARMAGENT_API_ROOT;
	}

	public get webBaseUrl() {
		return this.config.ALARMAGENT_WEB_ROOT;
	}

	public get supportUrl() {
		return this.config.SUPPORT_URL;
	}

	public get rollbarAccessToken() {
		return this.config.ROLLBAR_ACCESS_TOKEN;
	}

	private config: ConfigFile = new ConfigFile();

	constructor(private http: HttpClient, appInit: ApplicationInitStatus) {
		appInit.donePromise.then(() => this.onInit());
	}

	onInit() {
		this.loadConfig();
	}

	async loadConfig(): Promise<boolean> {
		if(isDevMode()) return false;
		try {
			const result: any = await this.http.get('config.json').toPromise();
			this.config = { ...this.config, ...result }; // merge the two, with the items in result "winning"
		} catch (err) {
			console.log('No config file found, running in local mode');
		}

		return true;
	}
}

class ConfigFile {
	public ALARMAGENT_WEB_ROOT: string = environment.web;
	public ALARMAGENT_API_ROOT: string = environment.api;
	public ROLLBAR_ACCESS_TOKEN: string = environment.accessToken;
	public SUPPORT_URL: string = environment.supportUrl;
}
